import React, { lazy } from 'react';
import { Section, Button, Countdown } from './ui';
import { Check, CheckCircle2, XCircle, ShieldCheck } from 'lucide-react';
const CHECKOUT_URL = 'https://sistema-iphone-ads.myshopify.com/cart/add?id=46176935641285&quantity=1&return_to=/cart';
export const Benefits = () => {
  const benefits = ['Entender cómo empezar a vender iPhones aunque no tengas stock propio.', 'Saber cómo funciona la venta por pedido.', 'Conocer qué errores evitar antes de comprar tu primer equipo.', 'Identificar qué modelos pueden tener más salida.', 'Entender cómo trabajar con proveedores.', 'Aprender cómo comunicar ofertas en Instagram.', 'Crear contenido que genere confianza.', 'Usar anuncios para generar conversaciones.', 'Vender por WhatsApp o Instagram DM.', 'Evitar arrancar improvisando sin saber qué hacer.'];
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <Section data-id="element-315">
      <div className="text-center mb-12 max-w-3xl mx-auto" data-id="element-316">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-317">
          Después de ver el curso vas a tener mucha más claridad para…
        </h2>
      </div>
      <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 max-w-4xl mx-auto mb-12" data-id="element-318">
        {benefits.map((benefit, i) => <div key={i} className="flex items-start space-x-3" data-id="element-319">
            <Check className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-320" />
            <p className="text-zinc-300" data-id="element-321">{benefit}</p>
          </div>)}
      </div>
      <div className="text-center max-w-2xl mx-auto space-y-8" data-id="element-322">
        <p className="text-lg text-zinc-400 italic" data-id="element-323">
          "No te prometemos resultados mágicos. Te damos una estructura para que
          entiendas el negocio y sepas qué pasos dar."
        </p>
        <Button href={CHECKOUT_URL} className="w-full md:w-auto" data-id="element-324">
          Quiero acceder por $19.000
        </Button>
      </div>
    </Section>;
};
export const Offer = () => {
  const includes = ['Acceso al curso grabado.', 'Más de 110 recursos entre clases, videos y materiales prácticos de apoyo.', 'Módulos sobre cómo empezar sin stock.', 'Módulos sobre proveedores.', 'Módulos sobre logística.', 'Módulos sobre modelos de iPhone.', 'Módulos sobre marketing y ventas.', 'Estrategias para conseguir clientes.', 'Explicaciones para vender por conversación.', 'Acceso digital para avanzar a tu ritmo.'];
  return <Section id="oferta" className="bg-white/[0.02] border-y border-white/[0.05] backdrop-blur-sm" data-id="element-325">
      <div className="max-w-4xl mx-auto" data-id="element-326">
        <div className="text-center mb-10" data-id="element-327">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-328">
            Qué incluye el acceso de $19.000
          </h2>
        </div>

        <div className="bg-zinc-950/80 backdrop-blur-md md:backdrop-blur-xl border-2 border-blue-600/50 rounded-3xl p-6 md:p-12 shadow-[0_0_30px_rgba(37,99,235,0.1)] md:shadow-[0_0_50px_rgba(37,99,235,0.15)] relative overflow-hidden" data-id="element-329">
          <div className="absolute top-0 right-0 bg-blue-600 text-white text-xs md:text-sm font-bold px-3 md:px-4 py-1 rounded-bl-xl z-20" data-id="element-330">
            OFERTA ESPECIAL
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-331">
            <div className="space-y-8" data-id="element-332">
              {/* Mockup Image */}
              <div className="relative w-full aspect-video rounded-2xl overflow-hidden border border-zinc-800 shadow-md md:shadow-xl" data-id="element-333">
                <img src="https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?q=80&w=800&fm=webp&auto=format&fit=crop" alt="Sistema iPhone Ads Mockup" loading="lazy" decoding="async" width="1000" height="562" className="absolute inset-0 w-full h-full object-cover" data-id="element-334" />
                <div className="absolute inset-0 bg-zinc-950/70 flex flex-col items-center justify-center text-center p-6" data-id="element-335">
                  <h3 className="text-2xl font-black text-white tracking-tight mb-2" data-id="element-336">
                    SISTEMA IPHONE ADS
                  </h3>
                  <p className="text-blue-400 font-semibold uppercase tracking-widest text-sm mb-4" data-id="element-337">
                    Curso Digital
                  </p>
                  <div className="flex flex-wrap justify-center gap-2" data-id="element-338">
                    <span className="bg-zinc-900/80 border border-zinc-700 text-xs text-zinc-300 px-2 py-1 rounded" data-id="element-339">
                      Clases + materiales
                    </span>
                    <span className="bg-zinc-900/80 border border-zinc-700 text-xs text-zinc-300 px-2 py-1 rounded" data-id="element-340">
                      Negocio + Marketing
                    </span>
                  </div>
                </div>
              </div>

              <ul className="space-y-3" data-id="element-341">
                {includes.map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-342">
                    <CheckCircle2 className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" data-id="element-343" />
                    <span className="text-zinc-300" data-id="element-344">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-zinc-900/60 backdrop-blur-sm md:backdrop-blur-md rounded-3xl p-6 md:p-8 text-center border border-white/[0.05] shadow-md md:shadow-xl relative overflow-hidden" data-id="element-345">
              <div className="absolute inset-0 bg-gradient-to-b from-blue-500/5 to-transparent pointer-events-none" data-id="element-346"></div>

              <div className="inline-flex items-center space-x-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full px-3 py-1 mb-6" data-id="element-347">
                <span className="flex h-2 w-2 rounded-full bg-emerald-500 animate-pulse" data-id="element-348"></span>
                <span className="text-xs font-bold text-emerald-400 uppercase tracking-wider" data-id="element-349">
                  Oferta Activa
                </span>
              </div>

              <p className="text-2xl font-bold text-white mb-2" data-id="element-350">
                Accedé hoy con precio especial
              </p>
              <p className="text-zinc-400 text-sm mb-6" data-id="element-351">
                Esta oferta especial está activa durante la cuenta regresiva.
              </p>

              <div className="mb-6" data-id="element-352">
                <Countdown data-id="element-353" />
              </div>

              <p className="text-center text-sm font-bold text-amber-300 mb-3" data-id="element-354">
                Te quedan pocos minutos para entrar con precio especial.
              </p>

              <Button href={CHECKOUT_URL} className="w-full mb-6 py-5 text-xl shadow-[0_0_30px_rgba(16,185,129,0.15)]" data-id="element-355">
                Quiero acceder por $19.000
              </Button>

              <div className="space-y-3" data-id="element-356">
                <p className="text-sm text-white font-semibold leading-relaxed bg-zinc-950/60 p-3 rounded-lg border border-amber-500/20" data-id="element-357">
                  Cuando el contador llegue a cero, el precio regular será
                  $40.000.
                </p>
                <p className="text-xs text-zinc-500 leading-relaxed" data-id="element-358">
                  El acceso de $19.000 corresponde al curso digital grabado. No
                  incluye acompañamiento grupal ni personalizado.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
};
export const TargetAudience = () => {
  return <Section data-id="element-359">
      <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-360">
        <div className="bg-zinc-900/50 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.05] rounded-3xl p-6 md:p-8 shadow-md md:shadow-xl" data-id="element-361">
          <h2 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-362">
            <CheckCircle2 className="w-6 h-6 text-emerald-500 mr-3" data-id="element-363" />
            Este curso es para vos si…
          </h2>
          <ul className="space-y-4" data-id="element-364">
            {['Querés empezar desde cero.', 'No tenés stock propio.', 'Tenés poco capital y querés moverte mejor.', 'Querés vender por pedido.', 'Querés entender el negocio antes de poner plata.', 'Querés aprender a conseguir clientes.', 'Querés vender por Instagram o WhatsApp.', 'Ya vendés iPhones y querés ordenar mejor tu sistema.'].map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-365">
                <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 mt-2 flex-shrink-0" data-id="element-366" />
                <span className="text-zinc-300" data-id="element-367">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-zinc-900/50 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.05] rounded-3xl p-6 md:p-8 shadow-md md:shadow-xl" data-id="element-368">
          <h2 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-369">
            <XCircle className="w-6 h-6 text-red-500 mr-3" data-id="element-370" />
            Este curso NO es para vos si…
          </h2>
          <ul className="space-y-4" data-id="element-371">
            {['Querés hacer plata rápido sin aprender.', 'Buscás resultados garantizados.', 'No estás dispuesto a aplicar nada.', 'Pensás que vender iPhones es solo subir una foto.', 'Querés una fórmula mágica.', 'No querés dedicar tiempo a entender el negocio.'].map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-372">
                <div className="w-1.5 h-1.5 rounded-full bg-red-500 mt-2 flex-shrink-0" data-id="element-373" />
                <span className="text-zinc-300" data-id="element-374">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
};
export const Differentiator = () => {
  return <Section className="bg-blue-900/10 border-y border-blue-500/20 backdrop-blur-sm" data-id="element-375">
      <div className="max-w-3xl mx-auto text-center" data-id="element-376">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-377">
          ¿Por qué este curso es diferente?
        </h2>
        <p className="text-xl text-zinc-300 mb-8" data-id="element-378">
          Porque está pensado específicamente para el negocio de iPhones.
        </p>

        <div className="grid sm:grid-cols-2 gap-4 text-left mb-10" data-id="element-379">
          {['No es marketing genérico.', 'No es un curso genérico de ventas.', 'No es solo aprender anuncios.', 'No es solo conseguir proveedores.', 'Une negocio real + marketing + venta por conversación.', 'Te muestra cómo pensar el negocio antes de arriesgar tu plata.'].map((item, i) => <div key={i} className="flex items-center space-x-3 bg-zinc-900/50 backdrop-blur-sm md:backdrop-blur-md p-4 rounded-xl border border-white/[0.05] shadow-sm md:shadow-lg" data-id="element-380">
              <ShieldCheck className="w-5 h-5 text-blue-400 flex-shrink-0" data-id="element-381" />
              <span className="text-zinc-300" data-id="element-382">{item}</span>
            </div>)}
        </div>

        <p className="text-2xl font-bold text-blue-400" data-id="element-383">
          "El objetivo es que no arranques a ciegas."
        </p>
      </div>
    </Section>;
};